<h3 mat-dialog-title>
  <mat-icon>print</mat-icon>
  <span>Download Config</span>
</h3>

<mat-dialog-content>
  <div *ngIf="printRequested">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <div *ngIf="error_message">
    <p>{{ error_message }}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-raised-button
    [disabled]="printRequested || !!error_message"
    (click)="downloadFile()">
    Download
  </button>

  <button mat-raised-button (click)="onNoClick()">
    Cancel
  </button>
</mat-dialog-actions>